import { IDonHangViewChiTietActionTypes } from "../../action-types/don-hang/IDonHangViewChiTietActions";
import { IDonHangViewChiTietItemReducer, IDonHangViewChiTietReducer } from "../../reducer-model/don-hang/IDonHangViewChiTietReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
export const iniStateItem: IDonHangViewChiTietItemReducer = {
    id: 0,
    status: eReducerStatusBase.is_not_initialization
}
const iniState: IDonHangViewChiTietReducer = {
    donHangs: []
}
export const donHangViewChiTietReducer = (state: IDonHangViewChiTietReducer = iniState, action: IDonHangViewChiTietActionTypes): IDonHangViewChiTietReducer => {
    switch (action.type) {

        case "DON_HANG_VIEW_CHI_TIET_GET_HTML_PRINT_START":
            return {
                ...state,
                donHangs: [
                    ...state.donHangs.filter(x => x.id !== action.payload),
                    {
                        ...(state.donHangs.find(x => x.id === action.payload) ?? iniStateItem),
                        status: eReducerStatusBase.is_loading
                    }
                ]
            }
        case "DON_HANG_VIEW_CHI_TIET_GET_HTML_PRINT_SUCCESS":
            return {
                ...state,
                donHangs: [
                    ...state.donHangs.filter(x => x.id !== action.payload.donHangId),
                    {
                        ...(state.donHangs.find(x => x.id === action.payload.donHangId) ?? iniStateItem),
                        status: eReducerStatusBase.is_completed,
                        htmlPrint: action.payload.data
                    }
                ]
            }
        case "DON_HANG_VIEW_CHI_TIET_GET_HTML_PRINT_ERROR":
            return {
                ...state,
                donHangs: [
                    ...state.donHangs.filter(x => x.id !== action.payload.donHangId),
                    {
                        ...(state.donHangs.find(x => x.id === action.payload.donHangId) ?? iniStateItem),
                        status: eReducerStatusBase.is_completed,
                        htmlPrint: undefined
                    }
                ]
            }
        case "DON_HANG_VIEW_CHI_TIET_INIT_DONHANG":
            return {
                ...state,
                donHangs: [
                    ...state.donHangs.filter(x => x.id !== action.payload),
                    {
                        ...(state.donHangs.find(x => x.id === action.payload) ?? iniStateItem),
                        id: action.payload,
                        status: eReducerStatusBase.is_not_initialization,
                        htmlPrint: undefined
                    }
                ]
            }
        default:
            return state;
    }
}